import store from "@/core/store"
import {GET_ACCOUNT} from "@/core/store/modules/account/constants"
import storage from "@/core/services/storage.service";

export default function auth({next, router}) {
    if (!store.getters.isAuthenticated) {
        if (window.location.pathname !== '/') {
            storage.local().set('redirect', window.location.href)
        }
        return router.push({
            name: 'login'
        }).catch(() => {
        });
    }
    if (!store.getters.hasAccount) {
        store.dispatch(GET_ACCOUNT).then((response) => {
            return next()
        }).catch(() => {
        })
    } else {
        return next();
    }

}
